const base = {
    // api: 'http://101.37.16.149/clientmanage/public/clientapi/portal/',
    // api: 'https://service.easennt.com/clientmanage/public/clientapi/portal/'
    api: 'https://service.easen.com/clientapi/portal/'
}
export default base;
